import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'

import fontawesome from '@fortawesome/fontawesome'
import regular from '@fortawesome/fontawesome-free-regular'
import solid from '@fortawesome/fontawesome-free-solid'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import Switch from 'views/Switch'
import Header from 'layouts/Header'
import AccountNav from 'components/AccountNav'

import { reverse, filterLinks } from 'utilities/routes'

import {
  PARENT_SIGNUP as ROUTE_PARENT_SIGNUP,
  LEADER_SIGNUP as ROUTE_LEADER_SIGNUP,
} from 'views/Signup/constants'

import { NAME } from './constants'
import reducer from './reducer'
import saga from './sagas'
import selector from './selectors'
import styles from './styles.css'

fontawesome.library.add(regular)
fontawesome.library.add(solid)

class App extends Component {
  static propTypes = {
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
    ]),
    accountKey: PropTypes.number.isRequired,
    location: PropTypes.object.isRequired,
  }

  static defaultProps = {
    account: false,
  }

  static linksLeft = [
    {
      label: 'Bli ledare',
      href: reverse(ROUTE_LEADER_SIGNUP),
      exceptRole: 'leader',
    },
    {
      label: 'Så funkar det',
      href: reverse('static/sa-funkar-det'),
    },
    {
      label: 'Pris, Q&A',
      href: reverse('static/fragor-och-svar'),
    },
    {
      label: 'Om oss',
      href: reverse('static/om-oss'),
    },
  ]

  static linksRight = [
    {
      label: 'Registrera dig som förälder',
      href: reverse(ROUTE_PARENT_SIGNUP),
      auth: false,
    },
  ]

  componentWillMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
  }

  componentWillUnmount() {
    removeReducer(NAME)
    removeSaga(NAME)
  }

  render() {
    const { account, accountKey, location } = this.props
    const { fullWidth } = location.routesMap[location.type]
    return (
      <div className={styles.root} key={accountKey}>
        <Helmet defaultTitle="friendtivity" titleTemplate="%s | friendtivity">
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=5"
          />
        </Helmet>

        <Header
          fullWidth={fullWidth}
          linksLeft={filterLinks(App.linksLeft, account)}
          linksRight={filterLinks(App.linksRight, account)}
          account={account}
        >
          {/* Hide AccountNav until we know whether we’re logged in or not. */}
          {account !== false && (
            <AccountNav account={account && account.toJS()} />
          )}
        </Header>

        <Switch />
        <ToastContainer position="bottom-center" />
      </div>
    )
  }
}

export default connect(selector)(App)



// WEBPACK FOOTER //
// ../source/views/App/index.js